import { WidgetType } from "@codemirror/view";

export class TildeWidget extends WidgetType {
    toDOM() {
        const element = document.createElement("span");
        element.textContent = "\u00a0";
        return element;
    }

    eq() {
        return true;
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}
